/**
* Downloads the picked Google photos onto our upload servers by batches of 5, handing each one over
* as soon as it lands ("google-converted-batch") so the import screen fills up while the rest arrives.
*/
fx.service(class GoogleConvertService extends fx.Service {
    constructor(model) {
        super();

        this.model = model.creationModel;

        this.on("event", this._dataEvent, this.model);

        this._reset();
    }

    // photos still waiting for the server, or a batch in flight
    get converting() {
        return this.queue.length > 0 || this.currentRequest.length > 0;
    }

    convert(photos) {
        this.queue = this.queue.concat(photos);

        this._process();
    }

    // drop what is left ; aborting deletes the callback, so the batch in flight can no longer answer
    cancel() {
        if (this._request)
            this.abort(this._request);

        this._reset();
    }

    _dataEvent(e) {
        switch (e.detail.event.type) {
            // the import screen waits on the end, so a bare reset would leave it waiting — but only
            // an import that was running has a screen to tell
            case "offline":
                if (this.converting) {
                    this.cancel();
                    this.trigger("google-convert-finished", { error: true });
                }
                else
                    this._reset();
                break;
        }
    }

    _process() {
        if (this.queue.length == 0) {
            this._reset();   // before announcing : the listeners read `converting` to close the import
            this.trigger("google-convert-finished", {});
        }
        else
            if (this.currentRequest.length == 0) {
                for (let i = 0; i < 5 && this.queue.length > 0; i++) // we send picture per 5
                    this.currentRequest.push(this.queue.shift());

                this._send();
            }
    }

    _send() {
        let photos = [];

        for (let i = 0; i < this.currentRequest.length; i++) {
            let photo = {
                media_id: this.currentRequest[i].id,
                url: this.currentRequest[i].fullSize_url ? this.currentRequest[i].fullSize_url : this.currentRequest[i].baseUrl
            };

            photos.push(photo);
        }

        // depending we are using config or editor
        let creation = this.model.creationModel || this.model.creation;

        this._request = this.post(fx.get("flutter") ? fx.service("GoogleUploader").uploadURL() : fx.service("MediasUploader").uploadURL(),
            {
                token: fx.service("GoogleService").token,
                creation_id: creation.id,
                mediatype: "google-photos",
                files: photos
            },
            this._onSend,
            { timeout: 0 }
        );
    }

    _onSend(data) {
        this._request = null;

        if (this.currentRequest.length == 0)
            return;

        if (data.error || data.success === false) {
            if (this.tries < 5) {
                this.queue = this.queue.concat(this.currentRequest);
                this.currentRequest = [];
                this.tries++;
                this._process();
            }
            else {
                this._reset();   // before announcing, as above : currentRequest still held this batch
                this.trigger("google-convert-finished", { error: true });
            }

        }
        else {
            let batch = [];

            for (let i = 0; i < this.currentRequest.length; i++) {
                if (data[i]) {
                    let { baseUrl, fullSize_url, id, mediaMetadata, thumb, createTime } = this.currentRequest[i];

                    batch.push({
                        server_url: data[i].url,
                        baseUrl,
                        fullSize_url: fullSize_url,
                        id,
                        thumb,
                        metaData: mediaMetadata,
                        createTime : createTime
                    });
                }
            }

            this.currentRequest = [];

            // hand it over before asking for the next : it is shown and uploaded meanwhile
            if (batch.length)
                this.trigger("google-converted-batch", batch);

            this._process();
        }
    }


    _reset() {
        this.queue = [];
        this.currentRequest = [];
        this.tries = 0;
        this._request = null;
    }
    //
});
